import React, { useEffect } from 'react'
import Header from 'components/Header'
import Footer from 'components/Footer'
import AboutUs from './components/AboutUs'

function About() {
  useEffect(() => {
    document.title = 'Agência Dorac - Quem Somos'
    window.scrollTo(0, 0)
  }, [])

  return (
    <main className='relative w-full bg-dorac-bg font-display text-dorac-ink'>
      <Header />
      <AboutUs />
      <Footer />
    </main>
  )
}

export default About
